import React,{ useState,useEffect } from "react";
import "./Create-Investment.css";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { resetSelectedUsers } from "../../Redux/store/selectedUserSlice";
import { useDispatch } from "react-redux";




const OtherDetails = ({setperformanceNote,setdisclaimer,setcopyrights,setaddMember,setaddToDashboard,showAll,preselectedAddToDashboard,preselectedAddUser,prePerformanceNotes,preDisclaimer,preCopyright}) => {

  const dropdownData = [
    { value: false, label: "No" },
    { value: true, label: "Yes" },
  ];
  const specificData = [
    { value: false, label: "No" },
    { value: true, label: "Yes" },
  ];
  const dispatch = useDispatch();

  const [performanceNotesChild, setperformanceNoteChild] = useState("");
  const [disclaimerChild, setdisclaimerChild] = useState("");
  const [copyrightsChild, setcopyrightschild] = useState("");
  const [addToDashboardChild, setaddToDashboardChild] = useState(false);
  const [addMemberChild, setaddMemberChild] = useState(false);
  useEffect(() => {
    if(preCopyright!=''){
      setcopyrightschild(preCopyright);
   }
  }, [preCopyright]);
  useEffect(() => {
    if(prePerformanceNotes!=''){
      setperformanceNoteChild(prePerformanceNotes);
   }
  }, [prePerformanceNotes]);
  useEffect(() => {
    if(preDisclaimer!=''){
      setdisclaimerChild(preDisclaimer);
   }
  }, [preDisclaimer]);
  const handleSelect = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setaddToDashboardChild(selectedOption.value)
    setaddToDashboard(selectedOption.value)
  };
  const handleSelectSpecific = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setaddMemberChild(selectedOption.value)
    setaddMember(selectedOption.value)
    if(selectedOption.value==false){
      dispatch(resetSelectedUsers());
    }
  };
  return (
    <div className="w-full p-6  mt-6 bg-white px-8  rounded-md shadow-sm">
        <div className="flex items-center  border-b border-colour-custom space-x-2  pt-2">
        <h1 className="text-lg font-semibold">Other Details</h1>

        </div>
     {showAll &&<div className="space-y-4 pt-4">
        {/* Historical Performance Note */}
        <div>
          <label
            htmlFor="historical-performance"
            className="block text-sm font-medium text-labelColour"
          >
            Historical Performance Note
          </label>
          <textarea
            id="historical-performance"
            rows="3"
            value={performanceNotesChild}
              onChange={(e) => {setperformanceNoteChild(e.target.value)
                setperformanceNote(e.target.value)
              }}
            className="w-full mt-2 p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-black"
            placeholder="Add notes here..."
          />
        </div>

        {/* Disclaimer */}
        <div>
          <label
            htmlFor="disclaimer"
            className="block text-sm font-medium text-labelColour"
          >
            Disclaimer
          </label>
          <textarea
            id="disclaimer"
            rows="3"
            value={disclaimerChild}
            onChange={(e) => {setdisclaimerChild(e.target.value)
              setdisclaimer(e.target.value)
            }}
            className="w-full mt-2 p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-black"
            placeholder="Add disclaimer here..."
          />
        </div>

        {/* Copyright */}
        <div>
          <label
            htmlFor="copyright"
            className="block text-sm font-medium text-labelColour"
          >
            Copyright
          </label>
          <textarea
            id="copyright"
            rows="3"
            value={copyrightsChild}
            onChange={(e) => {setcopyrightschild(e.target.value)
              setcopyrights(e.target.value)
            }}
            className="w-full mt-2 p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-black"
            placeholder="Add copyright details here..."
          />
        </div>
      </div>
}

      {/* Dropdowns */}
      <div className="flex flex-col sm:flex-row items-center mb-5 space-y-4 sm:space-y-0 sm:space-x-6 mt-6">
      {/* Add to Dashboard Dropdown */}
  <div className="w-full sm:w-1/2 lg:w-1/4">
    <Dropdown
      label="Add to Dashboard"
      options={dropdownData}
      onSelect={handleSelect}
      preselectedValue={preselectedAddToDashboard}
    />
  </div>

  {/* Accessible to Specific Customers Dropdown */}
  <div className="w-full sm:w-1/2 lg:w-1/4">
    <Dropdown
      label="Accessible to Specific Customers"
      options={specificData}
      onSelect={handleSelectSpecific}
      preselectedValue={preselectedAddUser}
    />
  </div>
</div>
    </div>
  );
};

export default OtherDetails;
